import gql from 'graphql-tag';

const GET_POOL_WHITELIST_STATE = gql`
    query getPoolWhitelistState (
        $poolId: String!
        $networkId: Float!
    ) {
        getPoolWhitelistState (getWhitelistParams : {
            poolId: $poolId,
            networkId: $networkId,
        }) {
                status,
                leaf,
                proof,
                address,
                whitelist,
                amount,
                networkId,
                contract,
                token,
                userTier,
        }
    }
`

export default GET_POOL_WHITELIST_STATE;